import React, {useEffect} from 'react';
import ResponsiveComponent from "../../../../../../components/Common/ResponsiveComponent";
import {useTranslation} from "react-i18next";
import {ReactComponent as ListIco} from "../../../../../../../images/icons/list.svg";
import {ReactComponent as MapIco} from "../../../../../../../images/icons/map.svg";

interface Props {
    view: "list" | "map";
    setView: React.Dispatch<React.SetStateAction<"list" | "map">>;
    setInnerWidth: React.Dispatch<React.SetStateAction<number>>;
}

const ToggleViewButton = ({view, setView, setInnerWidth}: Props) => {
    const {t} = useTranslation();

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setView("map");
            }
            setInnerWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [setView]);

    const handleToggle = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setView((prevState) => prevState === "map" ? "list" : "map");
        event.currentTarget.blur();
    };

    return (
        <ResponsiveComponent small={
            <button className="btn btn-default btn-icon btn-lg btn-primary view-button"
                    onClick={handleToggle}
                    aria-label={view === "list" ? t("modules.multistore.field.map_view.title") : t("modules.multistore.field.list_view.title")}
            >
                {view === "list" ? <MapIco aria-hidden="true"/> : <ListIco aria-hidden="true"/>}
            </button>
        } large={<></>} breakpoint={769}/>
    )
}

export default ToggleViewButton;